<template>
  <div>
    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          {{ $t("ADMISSION_DATA.STEP3.TERMS") }}
        </v-card-title>

        <v-card-text class="py-5">
         <div v-if="this.$store.state.curLanguage == 'ar' &&  getFoundation()==='5' ">
           <ul>
             <li>أقر أن كافة البيانات الواردة بطلب الالتحاق صحيحة ومطابقة للواقع وسيتم دعمها بالمستندات الأصلية فوراً حال طلبها وإلا سوف تلغى إستمارة التقديم تلقائياً.</li>
             <li>وأنني اطلعت علي شروط القبول المُعلنة على الموقع الإلكتروني للجامعة واستوعبت محتواه.</li>
             <li>وأنني علي علم بأن  مصاريف امتحان تحديد المستوي للغة الإنجليزية لا تسترد نهائياً.</li>
             <li>وانه فى حالة سحب الملف قبل بداية الدراسة سوف يتم خصم ما قيمته 10 % من رسوم تسجيل المقرراتالاسترداد بعد بدء الدراسة ولمدة شهر يتم استرداد 50% من قيمة الساعات المسجلة</li>
             <li>- الاسترداد بعد شهر من بدء الدراسة لأيتم استرداد المصروفات المسددة بالكامل.</li>
             <li>- ملحوظة : رسوم تقديم طلب الالتحاق والمصروفات الإدارية لا تسترد نهائياً</li>
             <li>· سداد الرسوم الدراسية بعد المواعيد المقررة بكل فصل دراسي يترتب عليه سداد غرامة التأخير طبقاً لنسبة التي يقررها مجلس الجامعة من بدء المحاضرات وذلك وفقاً للتقويم الأكاديمي لكل عام جامعي ،
                    وأنني علي علم بأنه سيتم زيادة قيمة الرسوم الدراسية فى حدود 10% سنوياً.ً</li>
              <li> في حالة قبولي فسوف اتبع كافة الشروط والقواعد المعلنة من قبل الجامعة.</li>
              <li>وأنني على علم أنة لن يتم قبول تسجيلي بالجامعة إلا بعد تقديم أصول مستندات الالتحاق(اصول الشهادات الخاصة بالطالب مختومة وموثقة من الجهات التابعة لها لكل شهادة )</li>
              <li>و وسداد الرسوم الدراسية خلال 24 ساعه
                    يوم من إعلان اسمي ضمن المقبولين وفقاً لمراحل التنسيق وأنني علي علم أنه في حالة عدم تسجيلي للمقررات وعدم سدادي لرسوم الفصل الدراسي الاول للعام الجامعي
                    2026/2025
                    اعتماد قبولي من مكتب قبول الجامعات الخاصة والأهلية بوزارة التعليم العالي قبل انعقاد امتحانات نهاية الفصل الدراسي الاول للعام الجامعي
                     في المواعيد المحددة يعد تنازلاً مني عن حقي بالقيد في الجامعة وسقوط قيدي بالوزارة،
                    وأنة لن يتم السماح لي بتسجيل مقررات المستوى الرابع إلا بعد اجتياز دورة التربية العسكرية ((للطلاب الذكور )) والتربية الوطنية بالنسبة للطالبات أو امتحان المواد التكميلية ((للحاصلين على الثانوية الأجنبية )). و التزامي بسياسة قنوات التواصل الاجتماعي،
                    كما أنه في حالة انتهاء قيدي بالجامعة سواء بالتخرج أو أي سبب أخر ألتزم بسحب أوراقي خلال ٦٠ يوم من انتهاء القيد بالجامعة ولا يحق لي مطالبة الجامعة بأية أوراق بعد هذه المدة.</li>
             <li class="text-decoration-underline" >أقر أنني قرأت ووافقت على جميع الشروط والأحكام المبينة أعلاه كما أتعهد بإخطار الجامعة فور تغيير أية بيانا خاصة بمحل الإقامة والمراسلة وأرقام التليفونات وإلا اتحمل انا كامل المسئولية عما يترتب عن ذلك</li>
           </ul>
         </div>

          <div v-if="this.$store.state.curLanguage == 'ar' &&  getFoundation()!=='5' ">
           <ul>
             <h4 class="text-decoration-underline">أتعهد وأقر بإطلاعي وموافقتي علي الاتيً.</h4>
             <li>	جميع البيانات الواردة بطلب الإلتحاق والمستندات صحيحة وعلي مسئوليتي .</li>
               <li>	أتعهد بتقديم أصول جميع المستندات اللازمة للإلتحاق بالجامعة .</li>
             <li>	اقر بانه فى حال قبولى بالجامعة يكون قبول مبدئى وليس نهائى . </li>
             <li>	اقر بأنه لن يتم تسجيلى بالجامعة إلابعد تقديم جميع أصول الشهادات والاوراق وإعتماد قبولي من مكتب القبول بالجامعات الأهلية التابع لوزارة التعليم العالي .</li>
             <li>	رسوم طلب الالتحاق لا ترد .</li>
             <li >.في حالة الرغبة في سحب الملف تطبق قواعد إسترداد المصروفات وفقاً للاجراءات المعمول بها بالجامعة علماً بأنه لايجوز سحب الملف أو تحويله إلا من خلال ولي الأمر ( الاب) أو من ينوب عنه بتوكيل رسمي خاص يبيح ذلك او بولاية تعليمية او قرار وصايه وذلك دون أدنى مسئولية على الجامعة  </li>
             <li >أقر بإطلاعي وموافقتي علي ما جاء في قواعد وسياسات القبول للطلاب المستجدين والمعمول بها بالجامعة. </li>
             <h4 class="text-decoration-underline"> يٌلغي طلب الإلتحاق بالكلية ولا يحق لى الرجوع على الجامعة . </h4>
             <li >عدم استيفاء اصول الاوراق والشهادات </li>
             <li >عدم إستيفاء الطالب الحد الادني للدرجات بالكلية التي يرغب الإلتحاق بها</li>
             <li >عدم التمكن من تسجيل اسم الطالب علي الموقع الخاص بالوزارة</li>
             <li >عدم سداد الرسوم والمصروفات الدراسية في المواعيد المحددة لها</li>
           </ul>
         </div>

         <div v-if="this.$store.state.curLanguage != 'ar' &&  getFoundation()!=='5' ">
           <ul>
             <li>I certify that all data provided in the application form are true and true and will be supported by the original documents immediately upon request, otherwise the application form will be canceled automatically.</li>
             <li>I have read the admission requirements announced on the university’s website and have absorbed its content, and I am aware that the fees for each application form, the level-setting exam, and the registration of the semester for the academic year are not final refunded, and that the payment of tuition fees after the dates set for each academic semester entails the payment of the delay fine according to the decision The University Council in this regard, as it is charged 30% of the fees for registration of decisions in addition to administrative fees in the event of withdrawal from the university before the end of the first week of the start of the lectures and does not recover or recover any fees in the case of withdrawal after the end of the second week of the start of the lectures, according to the calendar Academic year for each academic year.</li>
             <li>I am aware that the value of tuition fees will be increased in the range of 10% annually and that if I accept, I will follow all the conditions and rules announced by the university.</li>
             <li>I am aware that my registration will not be accepted to the university except after submitting the original documents of enrollment and acceptance approval from the Office of Private and Private Universities Admission of the Ministry of Higher Education before the end of semester exams and the payment of tuition fees within a day of my name being declared among the admitted according to the stages of coordination and that I am aware that In the case of not registering for the courses and not paying my semester fees in the specified dates, it is a waiver of my right to enroll in the university and my enrollment in the Ministry, and that I will not be allowed to register the decisions of the fourth year except after passing a military education course ((for male students)) or supplementary exams ((For those holding a foreign high school)).</li>
             <li>With my commitment to the social media channels policy.</li>
             <li>in the event that my enrollment in the university ends, whether for graduation or any other reason, I commit to withdraw my papers within 60 days of the end of enrollment in the university and I am not entitled to ask the university for any papers after this period.</li>
             <li class="text-decoration-underline

">I acknowledge that I have read and agreed to all the terms and conditions set out above as I pledge to notify the university as soon as any statement regarding the place of residence, correspondence and telephone numbers is changed, otherwise I bear full responsibility for the consequences.</li>
           </ul>
         </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false">
            {{ $t("CLOSE") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "ad-Terms",
  props: ["on"],
  data() {
    return {
      dialog: false
    };
  },
  watch: {
    dialog() {
      this.$emit("change", this.dialog);
    }
  },
  computed: {},
  created() {
    this.dialog = this.on;
  },
  mounted() {},
  methods: {
    getFoundation() {
      return localStorage.getItem("foundationId");
    },

  }
};
</script>
